import { ActionTypes } from "../constants/action-types";

const initialState = {
  events: [], 
  error: null, 
};

export const UploadlatestwebinarReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_WEBINAR_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload.events || [], 
        error: null, 
      };
    case ActionTypes.FETCH_WEBINAR_EVENTS_FAILURE:
      return {
        ...state,
        error: action.payload, 
      };
    default:
      return state;
  }
};

export default UploadlatestwebinarReducer;
